import { render } from "./SubmitButton.vue?vue&type=template&id=a5aa0392&ts=true"
import script from "./SubmitButton.vue?vue&type=script&lang=ts"
export * from "./SubmitButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__